const ADS_ID = process.env.REACT_APP_GOOGLE_ADS_ID;

export const initAds = () => {
  if (!ADS_ID || document.getElementById("ga-ads-tag")) return;
  const s = document.createElement("script");
  s.id = "ga-ads-tag";
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${ADS_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", ADS_ID);
};

export const trackLead = (type) => {
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "generate_lead", lead_type: type });
    if (window.gtag) {
      window.gtag("event", "generate_lead", { event_category: "leads", event_label: type });
    }
  } catch {
    /* tracking must never break the booking flow */
  }
};
